import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Flex, Text, Button } from "ui-components";
import "./styles.css";
import {
  getSignPassLinkUrl, buildJumioAuthHeaders, pathWithChannel, getMyInfoAuthorisedURL
} from "utils/helpers";
import FormattedMessage from "components/FormattedMessage";
import Logo from "assets/images/singpass_logo.png";
import LogoWhite from "assets/images/singpass_logo_white.png";
import { getButtonColorVariant, buttonThemes } from "ui-components/theme";
import styles from "./styles";
import Spinner from "components/Spinner";
import { setData, getSignPassLinkFulfilmentUrl } from "ducks/actions";
import { paths } from "utils/constants";

const MyInfoBox = ({
  title,
  btnLabel,
  fieldNameToClear,
  clearInfoLabel,
  setMyInfoIsUsed,
  clearMyInfoFormFields,
  clearMyInfoUrlParam,
  clearMyInfoDomain,
  myInfoIsUsed,
  appSettings,
  jumioSessionToken,
}) => {
  const isSignpassFulfilment = appSettings?.enable_signpass_fulfillment_flow ?? false;
  const link = !isSignpassFulfilment && getMyInfoAuthorisedURL(appSettings);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleOnloginWithMyInfoClick = async () => {
    setIsLoading(true);
    try {
      const headers = buildJumioAuthHeaders(jumioSessionToken);
      const params = {
        redirect_uri: pathWithChannel(
          window.location.origin + paths.ENTERPRISE_AUTOMATED_EKYC
        ),
      };
      await dispatch(
        getSignPassLinkFulfilmentUrl(headers, params, (response) => {
          const link = getSignPassLinkUrl(response);
          if (link) {
            window.location.assign(link);
          }
        })
      );
    } catch (err) {
      console.error("API Error", err);
    } finally {
      // setIsLoading(false);
    }

    dispatch(setData({ key: "MyInfoEvent" }));
  };

  return (
    <Box width="100%" textAlign="left" pt={3} pb={2}>
      {/* Title */}
      <Text
        fontSize="32px"
        fontWeight="700"
        color="#0f172a"
        mb={3}
        sx={styles.title}
      >
        {title ? (
          <FormattedMessage html id={title} values={{ logo: Logo }} />
        ) : (
          "Identity verification"
        )}
      </Text>

      <FormattedMessage html id={'ent_singpass_content'} />
      {/* Action Button */}
      <Flex justifyContent="center" width="100%" mt={2}>
          <Button
            variant="primary"
            sx={getButtonColorVariant(buttonThemes?.singpass)}
            as={isSignpassFulfilment ? undefined : "a"}
            href={isSignpassFulfilment ? undefined : link}
            onClick={handleOnloginWithMyInfoClick}
          >
            {isLoading ? (
              <Spinner size={19} />
            ) : (
              <FormattedMessage
                html
                id={btnLabel || "my_info_retrieve_button"}
                values={{ logo: LogoWhite }}
              />
            )}
          </Button>
      </Flex>
    </Box>
  );
};

MyInfoBox.defaultProps = {
  fieldNameToClear: [],
  btnLabel: "my_info_retrieve_button",
  clearInfoLabel: "my_info_clear_info_button"
};

export default MyInfoBox;